import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import BulkIdRegisterReducer from './BulkIdRegisterReducer';
import { bulkIdRegisterReducerKey } from './BulkIdRegisterConstants';
import BulkIdRegister from './BulkIdRegister';
import { setData, init, submit, setLoginFail } from './BulkIdRegisterActions';
import {
  ipAddress as ipAddressSelector,
  isLoading as isLoadingSelector,
  loginFail as loginFailSelector,
  data as dataSelector,
} from './BulkIdRegisterSelectors';
import { withCombinedRouteParams } from '../../../AppRoutes/ConnectedRoute';

const mapStateToProps = (state, ownProps) => ({
  ipAddress: ipAddressSelector(state),
  isLoading: isLoadingSelector(state),
  loginFail: loginFailSelector(state),
  data: dataSelector(state),
  ...ownProps,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  setData: (data) => dispatch(setData(data)),
  init: () => dispatch(init()),
  submit: () => dispatch(submit()),
  clearLoginFail: () => dispatch(setLoginFail(null)),
  ...ownProps,
});

function BulkIdRegisterContainer(props) {
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
  }, []);
  return <BulkIdRegister {...props} />;
}

export default compose(
  withCombinedRouteParams,
  withReducer(bulkIdRegisterReducerKey, BulkIdRegisterReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(BulkIdRegisterContainer);
